import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPowerOff, faUnlockAlt, faCircleDot } from "@fortawesome/free-solid-svg-icons";
import Line from "../line/Line";
import { useContext } from "react";
import { UserContext } from "../user/UserContext";

const UserDropdown = () => {
  const user = useContext(UserContext);

  const name = user.firstName;
  const surname = user.lastName;

  const logoutHandler = () => {
    user.logout();
  };

  return (
    <div className="card-dropdown">
      <div className="card-content p-4">
        <div className="mb-1 p-2 has-text-weight-bold">
          {name} {surname}
        </div>
        <Line color={"purple-dark"} />
        <div className="is-flex p-2">
          <span className="icon mr-2">
            <FontAwesomeIcon icon={faCircleDot} />
          </span>
          <div className="is-flex is-flex-direction-column">
            <p>e-mail: </p>
            <p className="has-text-purple-dark">{user && user.email}</p>
          </div>
        </div>

        <Line color={"grey"} height={1} />
        <div className="is-flex p-2">
          <span className="icon mr-2">
            <FontAwesomeIcon icon={faUnlockAlt} />
          </span>
          <a
            className="has-text-black"
            href={`${process.env.REACT_APP_STS_AUTHORITY}/Account/ForgotPassword`}
          >
            Promijeni lozinku
          </a>
        </div>

        <Line color={"grey"} height={1} />
        <div className="is-flex p-2">
          <span className="icon mr-2">
            <FontAwesomeIcon icon={faPowerOff} />
          </span>
          <p className="has-text-black is-clickable" onClick={logoutHandler}>
            Odjavi se
          </p>
        </div>
      </div>
    </div>
  );
};

export default UserDropdown;
